module.exports = __webpack_public_path__ + "img/5.789a8ac3.png";